import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues, ref } from '@dbk-legacy/muster/utils';
import calendar from './calendar-modal';
import format from 'date-fns/format';
import ui from '../data/ui.json';
import startOfYesterday from 'date-fns/start_of_yesterday';
import { Alert } from 'react-native';
import { addDays, addMonths, dateDiff, ymd } from '../utils/date';
import PdfDownload from '../utils/attachment-download';


export default () => {

  const yesterday = startOfYesterday();
  const past7Days = addDays(-6, yesterday);

  return muster()

    .path('advices.getAdvicesData', {
      call: async ({ req }, { get, set, call }) => {
        await call('report.setBusy');
        setTimeout(async () => {
          var fromDate = await getValues(get('advices.fromDate'));
          var toDate = await getValues(get('advices.toDate'));
          var portfolioId = await getValues(get('app.user.selectedPortfolioId'));
          const { outputType } = req.args[0];

          const [assetItems] = await getValues(get([`roster.data.advices.getAdvicesData["${fromDate}"]["${toDate}"]["${portfolioId}"]["${outputType}"]`]));
          await set('report.busy', false);
          await set('advices.advicesItemLists', JSON.parse(assetItems));
        }, 150);

      }
    })

    .path('advices.getSelectedAdviceItem', {
      call: async ({ req }, { get, set, call }) => {
        await set('report.busy', true);
        var fromDate = req.args[0].adviceItem.date.toString();
        var toDate = req.args[0].adviceItem.date.toString();
        var outputType = req.args[0].adviceItem.outputType;
        var item = req.args[0].adviceItem.item;
        var portfolioId = await getValues(get('app.user.selectedPortfolioId'));

        const [selectedAdviceLists] = await getValues(get([`roster.data.advices.getSelectedAdviceItem["${fromDate}"]["${toDate}"]["${portfolioId}"]["${outputType}"]`]));
        await set('advices.selectedAdviceLists', JSON.parse(selectedAdviceLists));
        await set('advices.selectedDate', fromDate);
        await set('report.busy', false);
        await set('advices.selectedItems', item);
        await set('advices.portfolioId', portfolioId)
        // await call('ui.history.push', { pathname: '/reports/adviceStatement' });
      }
    })

    .path('advices.onCalendarDone', {
      call: async ({ req }, { get, set, call }) => {
        const  from= req.args[0];
        const  to= req.args[1];
        var portfolioId = await getValues(get('app.user.selectedPortfolioId'));
        if (from || to) {
          await set('advices.fromDate', from);
          await set('advices.toDate',to);
          //await set('advices.isDateBarClickable', true);
        }
        await call('advices.getAdvicesData', { outputType: 'advices' });
      },
    })

    .import('advices.calendar', calendar(), {
      onDone: ref('advices.onCalendarDone')
    })

    .path('advices.getPdf', {
      call: async ({ req }, { get, set, call }) => {
        let { docId } = req.args[0];
        let params = {
          docId: docId
        }
        await call('reports.getPdfBinary', params);
        return;
      },
    })

    .path('advices.resetDates', {
      call: ({ req }, { set }) => {
        set('advices.fromDate', ymd(past7Days));
        set('advices.toDate', ymd(yesterday));
      },
    })

    .path('advices.fromDate', variable(ymd(past7Days)))
    .path('advices.toDate', variable(ymd(yesterday)))
    .path('advices.pdf', variable())
    .path('advices.isDateBarClickable', variable(false))
    .path('advices.selectedDate', variable())
    .path('advices.selectedItems', variable())
    .path('advices.portfolioId', variable())
    .path('advices.advicesItemLists', variable())
    .path('advices.selectedAdviceLists', variable())
}